import { toast } from "sonner";
import { Code2, Copy } from "lucide-react";

const SNIPPET = `<script async src="${process.env.REACT_APP_BACKEND_URL}/api/public/track.js" data-site="prime"></script>`;

export const AudienceSnippet = () => {
  const copy = () => navigator.clipboard.writeText(SNIPPET).then(() => toast.success("Code copié")).catch(() => toast.error("Copie impossible : sélectionnez le code manuellement"));
  return (
    <section className="bg-white border border-slate-200 rounded-md p-5" data-testid="aud-snippet">
      <h2 className="font-display font-bold text-lg flex items-center gap-2"><Code2 className="h-5 w-5" />Installation du suivi</h2>
      <p className="text-xs text-slate-500 mt-1 mb-3">
        solutions-prime.fr (accueil, pôles, contact, mentions légales) et la page XALTIX font partie de cette application : <b>elles sont suivies automatiquement, aucun code à ajouter</b>.
        Le code ci-dessous ne sert que si vous créez un jour un autre site, hébergé ailleurs, à suivre dans ce tableau.
      </p>
      <div className="flex gap-2 items-start">
        <code className="flex-1 block bg-slate-900 text-emerald-200 text-xs rounded-md px-3 py-2.5 break-all" data-testid="aud-snippet-code">{SNIPPET}</code>
        <button onClick={copy} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-[#0B2A7A] text-white text-xs font-semibold shrink-0" data-testid="aud-snippet-copy"><Copy className="h-4 w-4" />Copier</button>
      </div>
      <p className="text-[11px] text-slate-500 mt-2">Le suivi de vos pages démarre dès la prochaine mise en ligne de XALTIX.</p>
    </section>
  );
};
